import { FormStepId } from 'shared/config/formStepId';

import accuracy1Lottie from './assets/accuracy1.lottie';
import accuracy2Lottie from './assets/accuracy2.lottie';
import accuracy3Lottie from './assets/accuracy3.lottie';
import accuracy4Lottie from './assets/accuracy4.lottie';

type TCreditCardFormProgressConfigItem = {
  accuracy: string;
  percent: number;
  stepLabel: string;
  src?: string;
};

export const CREDIT_CARD_FORM_PROGRESS_CONFIG: Record<FormStepId, TCreditCardFormProgressConfigItem> = {
  [FormStepId.CreditPurposeInfo]: {
    accuracy: 'Низкая',
    percent: 10,
    stepLabel: 'первый',
    src: accuracy1Lottie,
  },
  [FormStepId.ContactsInfo]: {
    accuracy: 'Низкая',
    percent: 20,
    stepLabel: 'второй',
    src: accuracy1Lottie,
  },
  [FormStepId.PassportInfo]: {
    accuracy: 'Средняя',
    percent: 60,
    stepLabel: 'третий',
    src: accuracy2Lottie,
  },
  [FormStepId.WorkplaceInfo]: {
    accuracy: 'Высокая',
    percent: 80,
    stepLabel: 'четвертый',
    src: accuracy3Lottie,
  },
  [FormStepId.AdditionalInfo]: {
    accuracy: 'Максимальная',
    percent: 100,
    stepLabel: 'пятый',
    src: accuracy4Lottie,
  },
};
